export default "/_next/static/chunks/fonts/WhitneySSm-MediumItalic-Pro_Web-c58940023824ae935064284fa16da03c.woff";